import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { Observable } from '@apollo/client';


// Create an error link to handle network errors globally
const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (networkError) {
    console.error('Network Error: ', networkError);

    // Define maximum retries and initial delay
    let retryCount = 0;
    const maxRetries = 5;
    const initialDelay = 5000; // 5 seconds

    // Retry logic with exponential backoff
    return new Observable((observer) => {
      const retry = () => {
        // Increment delay exponentially
        const delay = initialDelay * Math.pow(2, retryCount - 1);

        // Retry the operation after delay
        const timeoutId = setTimeout(() => {
          forward(operation).subscribe({
            next: (result) => {
              observer.next(result);
              observer.complete();
            },
            error: (error) => {
              retryCount++;
              if (retryCount <= maxRetries) {
                retry(); // Retry with increased delay
              } else {
                observer.error(error); // Stop retrying after max attempts
              }
            },
          });
        }, delay);
        
        // Clear timeout when subscription is cancelled
        return () => clearTimeout(timeoutId);
      };

      retry(); // Start the retry loop
    });
  }

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      if(message=="Access denied! You need to be authenticated to perform this action!"){
        sessionStorage.clear();
        localStorage.clear();
        window.location="/";
      }
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
    });
  }
});


// //==============================> Development env

// export const liveStatusEndPoint = "https://automation.wfc360.com";

// export const baseURL = "http://localhost:3000";
// const graphqlEndpoint =  "http://localhost:4000/graphql"; 


//   const httpLink = createHttpLink({
//     uri: graphqlEndpoint,
//   });


//   const authLink = setContext((_, { headers }) => {
//     // get the authentication token from local storage if it exists
//     const token = localStorage.getItem('authToken');
//     // return the headers to the context so httpLink can read them
//     return {
//       headers: {
//         ...headers,
//         authorization: token ? `Bearer ${token}` : "",
//         credentials: 'include',
//       },
//     }
//   });


//   export const privateClient = new ApolloClient({
//     // link: authLink.concat(httpLink),
//     link: ApolloLink.from([errorLink,  authLink.concat(httpLink)]),
//     cache: new InMemoryCache()
//   });


//   export const publicClient = new ApolloClient({
    
//     uri: graphqlEndpoint,
    
//     cache: new InMemoryCache(),

//   });


//===========================> Production env

// local run: REACT_APP_AUTOMATION_URL=http://localhost:3500 (wfc-automation renders report PDFs)
// and REACT_APP_REPORT_BASE_URL=http://localhost:3000 (wfc-public's report pages it opens)
export const liveStatusEndPoint = process.env.REACT_APP_AUTOMATION_URL || "https://automation.wfc360.com";

export const baseURL = process.env.REACT_APP_REPORT_BASE_URL || "https://portal.wfc360.com";
// REACT_APP_SERVER_URL=http://localhost:4000 points a local run at a local wfc-server;
// builds without it (production) use the live backend
export const serverBaseURL = process.env.REACT_APP_SERVER_URL || "https://backend.wfc360.com";
const graphqlEndpoint =  `${serverBaseURL}/graphql`;

const httpLink = createHttpLink({
  uri: graphqlEndpoint,
  // credentials: 'include', 
});


const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('authToken');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      // credentials: 'include',
    },
  }
});


export const privateClient = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink.concat(httpLink)]),
  cache: new InMemoryCache()
});


export const publicClient = new ApolloClient({
  uri: graphqlEndpoint,
  cache: new InMemoryCache(),
});